import axios from "axios";
import { ServiceApi } from "./Api";

export class LaudoService {

  GetLaudo(studyUid) {
    try {
      return ServiceApi.get(`Api/Pedido/GetLaudoPorStudyUid?studyUid=${studyUid}`);
    } catch (error) {
      console.log(error);
    }
  }

  GetLaudoPdf(studyUid) {
    try {
      return ServiceApi.get(`Api/Pedido/GetResultadoPdfPorStudyUid?studyUid=${studyUid}`);
    } catch (error) {
      console.log(error);
    }
  }

  PostPossuiLaudo(studyUid) {
    try {
      return ServiceApi.post(`api/pedido/PostPossuiLaudo?studyUid=${studyUid}`);
    } catch (error) {
      console.log(error);
    }
  }
}
